import { debounce } from 'es-toolkit/compat';
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';

import { getCheckoutRouteSearch } from './checkoutRouteService';

const PUSH_ROUTE_DEBOUNCE = 200;

export const useCheckoutRouteUpdatingHook = () => {
    const navigate = useNavigate();
    const { pathname, search } = useLocation();
    const routeSearchToPushTo = useSelector(getCheckoutRouteSearch);

    const replaceRoute = useMemo(
        () =>
            debounce(
                (route: string) =>
                    navigate(route, {
                        replace: true,
                    }),
                PUSH_ROUTE_DEBOUNCE
            ),
        [navigate]
    );

    useEffect(() => {
        if (search !== `?${routeSearchToPushTo}`) {
            replaceRoute(`${pathname}?${routeSearchToPushTo}`);
        }

        return () => replaceRoute.cancel();
    }, [replaceRoute, routeSearchToPushTo, pathname, search]);
};
